// source: type/reservation_group.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
goog.exportSymbol('proto.type.DeprecatedReservationGroup', null, global);
goog.exportSymbol('proto.type.ReservationGroup', null, global);
goog.exportSymbol('proto.type.ReservationGroup.FeatureProduct', null, global);
goog.exportSymbol('proto.type.ReservationGroup.Period', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.type.DeprecatedReservationGroup = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.type.DeprecatedReservationGroup, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.type.DeprecatedReservationGroup.displayName = 'proto.type.DeprecatedReservationGroup';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.type.ReservationGroup = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.type.ReservationGroup.repeatedFields_, null);
};
goog.inherits(proto.type.ReservationGroup, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.type.ReservationGroup.displayName = 'proto.type.ReservationGroup';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.type.ReservationGroup.FeatureProduct = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.type.ReservationGroup.FeatureProduct, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.type.ReservationGroup.FeatureProduct.displayName = 'proto.type.ReservationGroup.FeatureProduct';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.type.ReservationGroup.Period = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.type.ReservationGroup.Period, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.type.ReservationGroup.Period.displayName = 'proto.type.ReservationGroup.Period';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.type.DeprecatedReservationGroup.prototype.toObject = function(opt_includeInstance) {
  return proto.type.DeprecatedReservationGroup.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.type.DeprecatedReservationGroup} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.type.DeprecatedReservationGroup.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


if (jspb.Message.GENERATE_FROM_OBJECT) {

/**
 * The raw object form of DeprecatedReservationGroup as accepted by the `fromObject` method.
 * @record
 */
proto.type.DeprecatedReservationGroup.ObjectFormat = function() {
};

/**
 * Loads data from an object into a new instance of this proto.
 * @param {!proto.type.DeprecatedReservationGroup.ObjectFormat} obj
 *     The object representation of this proto to load the data from.
 * @return {!proto.type.DeprecatedReservationGroup}
 */
proto.type.DeprecatedReservationGroup.fromObject = function(obj) {
  var msg = new proto.type.DeprecatedReservationGroup();
  return msg;
};
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.type.DeprecatedReservationGroup}
 */
proto.type.DeprecatedReservationGroup.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.type.DeprecatedReservationGroup;
  return proto.type.DeprecatedReservationGroup.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.type.DeprecatedReservationGroup} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.type.DeprecatedReservationGroup}
 */
proto.type.DeprecatedReservationGroup.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.type.DeprecatedReservationGroup.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.type.DeprecatedReservationGroup.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.type.DeprecatedReservationGroup} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.type.DeprecatedReservationGroup.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.type.ReservationGroup.repeatedFields_ = [6,7];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.type.ReservationGroup.prototype.toObject = function(opt_includeInstance) {
  return proto.type.ReservationGroup.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.type.ReservationGroup} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.type.ReservationGroup.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    description: jspb.Message.getFieldWithDefault(msg, 3, ""),
    coverImageUrl: jspb.Message.getFieldWithDefault(msg, 4, ""),
    siteCategoryId: jspb.Message.getFieldWithDefault(msg, 5, ""),
    periodsList: jspb.Message.toObjectList(msg.getPeriodsList(),
    proto.type.ReservationGroup.Period.toObject, includeInstance),
    featureProductsList: jspb.Message.toObjectList(msg.getFeatureProductsList(),
    proto.type.ReservationGroup.FeatureProduct.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


if (jspb.Message.GENERATE_FROM_OBJECT) {

/**
 * The raw object form of ReservationGroup as accepted by the `fromObject` method.
 * @record
 */
proto.type.ReservationGroup.ObjectFormat = function() {
  /** @type {?|undefined} */
  this.id;

  /** @type {?|undefined} */
  this.name;

  /** @type {?|undefined} */
  this.description;

  /** @type {?|undefined} */
  this.coverImageUrl;

  /** @type {?|undefined} */
  this.siteCategoryId;

  /** @type {?|undefined} */
  this.periodsList;

  /** @type {?|undefined} */
  this.featureProductsList;
};

/**
 * Loads data from an object into a new instance of this proto.
 * @param {!proto.type.ReservationGroup.ObjectFormat} obj
 *     The object representation of this proto to load the data from.
 * @return {!proto.type.ReservationGroup}
 */
proto.type.ReservationGroup.fromObject = function(obj) {
  var msg = new proto.type.ReservationGroup();
  obj.id != null && jspb.Message.setField(msg, 1, obj.id);
  obj.name != null && jspb.Message.setField(msg, 2, obj.name);
  obj.description != null && jspb.Message.setField(msg, 3, obj.description);
  obj.coverImageUrl != null && jspb.Message.setField(msg, 4, obj.coverImageUrl);
  obj.siteCategoryId != null && jspb.Message.setField(msg, 5, obj.siteCategoryId);
  obj.periodsList && jspb.Message.setRepeatedWrapperField(
      msg, 6, obj.periodsList.map(
          proto.type.ReservationGroup.Period.fromObject));
  obj.featureProductsList && jspb.Message.setRepeatedWrapperField(
      msg, 7, obj.featureProductsList.map(
          proto.type.ReservationGroup.FeatureProduct.fromObject));
  return msg;
};
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.type.ReservationGroup}
 */
proto.type.ReservationGroup.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.type.ReservationGroup;
  return proto.type.ReservationGroup.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.type.ReservationGroup} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.type.ReservationGroup}
 */
proto.type.ReservationGroup.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setCoverImageUrl(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setSiteCategoryId(value);
      break;
    case 6:
      var value = new proto.type.ReservationGroup.Period;
      reader.readMessage(value,proto.type.ReservationGroup.Period.deserializeBinaryFromReader);
      msg.addPeriods(value);
      break;
    case 7:
      var value = new proto.type.ReservationGroup.FeatureProduct;
      reader.readMessage(value,proto.type.ReservationGroup.FeatureProduct.deserializeBinaryFromReader);
      msg.addFeatureProducts(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.type.ReservationGroup.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.type.ReservationGroup.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.type.ReservationGroup} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.type.ReservationGroup.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getCoverImageUrl();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getSiteCategoryId();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getPeriodsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      6,
      f,
      proto.type.ReservationGroup.Period.serializeBinaryToWriter
    );
  }
  f = message.getFeatureProductsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      7,
      f,
      proto.type.ReservationGroup.FeatureProduct.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.type.ReservationGroup.FeatureProduct.prototype.toObject = function(opt_includeInstance) {
  return proto.type.ReservationGroup.FeatureProduct.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.type.ReservationGroup.FeatureProduct} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.type.ReservationGroup.FeatureProduct.toObject = function(includeInstance, msg) {
  var f, obj = {
    productId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    imageUrl: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


if (jspb.Message.GENERATE_FROM_OBJECT) {

/**
 * The raw object form of FeatureProduct as accepted by the `fromObject` method.
 * @record
 */
proto.type.ReservationGroup.FeatureProduct.ObjectFormat = function() {
  /** @type {?|undefined} */
  this.productId;

  /** @type {?|undefined} */
  this.name;

  /** @type {?|undefined} */
  this.imageUrl;
};

/**
 * Loads data from an object into a new instance of this proto.
 * @param {!proto.type.ReservationGroup.FeatureProduct.ObjectFormat} obj
 *     The object representation of this proto to load the data from.
 * @return {!proto.type.ReservationGroup.FeatureProduct}
 */
proto.type.ReservationGroup.FeatureProduct.fromObject = function(obj) {
  var msg = new proto.type.ReservationGroup.FeatureProduct();
  obj.productId != null && jspb.Message.setField(msg, 1, obj.productId);
  obj.name != null && jspb.Message.setField(msg, 2, obj.name);
  obj.imageUrl != null && jspb.Message.setField(msg, 3, obj.imageUrl);
  return msg;
};
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.type.ReservationGroup.FeatureProduct}
 */
proto.type.ReservationGroup.FeatureProduct.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.type.ReservationGroup.FeatureProduct;
  return proto.type.ReservationGroup.FeatureProduct.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.type.ReservationGroup.FeatureProduct} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.type.ReservationGroup.FeatureProduct}
 */
proto.type.ReservationGroup.FeatureProduct.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setProductId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setImageUrl(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.type.ReservationGroup.FeatureProduct.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.type.ReservationGroup.FeatureProduct.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.type.ReservationGroup.FeatureProduct} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.type.ReservationGroup.FeatureProduct.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProductId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getImageUrl();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string product_id = 1;
 * @return {string}
 */
proto.type.ReservationGroup.FeatureProduct.prototype.getProductId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.type.ReservationGroup.FeatureProduct} returns this
 */
proto.type.ReservationGroup.FeatureProduct.prototype.setProductId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.type.ReservationGroup.FeatureProduct.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.type.ReservationGroup.FeatureProduct} returns this
 */
proto.type.ReservationGroup.FeatureProduct.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string image_url = 3;
 * @return {string}
 */
proto.type.ReservationGroup.FeatureProduct.prototype.getImageUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.type.ReservationGroup.FeatureProduct} returns this
 */
proto.type.ReservationGroup.FeatureProduct.prototype.setImageUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.type.ReservationGroup.Period.prototype.toObject = function(opt_includeInstance) {
  return proto.type.ReservationGroup.Period.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.type.ReservationGroup.Period} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.type.ReservationGroup.Period.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 1, ""),
    orderStartAt: (f = msg.getOrderStartAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    orderEndAt: (f = msg.getOrderEndAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    deliveryStartAt: (f = msg.getDeliveryStartAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    deliveryEndAt: (f = msg.getDeliveryEndAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    isVariedOrderDateByProduct: jspb.Message.getBooleanFieldWithDefault(msg, 6, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


if (jspb.Message.GENERATE_FROM_OBJECT) {

/**
 * The raw object form of Period as accepted by the `fromObject` method.
 * @record
 */
proto.type.ReservationGroup.Period.ObjectFormat = function() {
  /** @type {?|undefined} */
  this.name;

  /** @type {?|undefined} */
  this.orderStartAt;

  /** @type {?|undefined} */
  this.orderEndAt;

  /** @type {?|undefined} */
  this.deliveryStartAt;

  /** @type {?|undefined} */
  this.deliveryEndAt;

  /** @type {?|undefined} */
  this.isVariedOrderDateByProduct;
};

/**
 * Loads data from an object into a new instance of this proto.
 * @param {!proto.type.ReservationGroup.Period.ObjectFormat} obj
 *     The object representation of this proto to load the data from.
 * @return {!proto.type.ReservationGroup.Period}
 */
proto.type.ReservationGroup.Period.fromObject = function(obj) {
  var msg = new proto.type.ReservationGroup.Period();
  obj.name != null && jspb.Message.setField(msg, 1, obj.name);
  obj.orderStartAt && jspb.Message.setWrapperField(
      msg, 2, google_protobuf_timestamp_pb.Timestamp.fromObject(obj.orderStartAt));
  obj.orderEndAt && jspb.Message.setWrapperField(
      msg, 3, google_protobuf_timestamp_pb.Timestamp.fromObject(obj.orderEndAt));
  obj.deliveryStartAt && jspb.Message.setWrapperField(
      msg, 4, google_protobuf_timestamp_pb.Timestamp.fromObject(obj.deliveryStartAt));
  obj.deliveryEndAt && jspb.Message.setWrapperField(
      msg, 5, google_protobuf_timestamp_pb.Timestamp.fromObject(obj.deliveryEndAt));
  obj.isVariedOrderDateByProduct != null && jspb.Message.setField(msg, 6, obj.isVariedOrderDateByProduct);
  return msg;
};
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.type.ReservationGroup.Period}
 */
proto.type.ReservationGroup.Period.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.type.ReservationGroup.Period;
  return proto.type.ReservationGroup.Period.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.type.ReservationGroup.Period} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.type.ReservationGroup.Period}
 */
proto.type.ReservationGroup.Period.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setOrderStartAt(value);
      break;
    case 3:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setOrderEndAt(value);
      break;
    case 4:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setDeliveryStartAt(value);
      break;
    case 5:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setDeliveryEndAt(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsVariedOrderDateByProduct(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.type.ReservationGroup.Period.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.type.ReservationGroup.Period.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.type.ReservationGroup.Period} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.type.ReservationGroup.Period.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getOrderStartAt();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getOrderEndAt();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getDeliveryStartAt();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getDeliveryEndAt();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getIsVariedOrderDateByProduct();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.type.ReservationGroup.Period.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.type.ReservationGroup.Period} returns this
 */
proto.type.ReservationGroup.Period.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional google.protobuf.Timestamp order_start_at = 2;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.type.ReservationGroup.Period.prototype.getOrderStartAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 2));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.type.ReservationGroup.Period} returns this
*/
proto.type.ReservationGroup.Period.prototype.setOrderStartAt = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.type.ReservationGroup.Period} returns this
 */
proto.type.ReservationGroup.Period.prototype.clearOrderStartAt = function() {
  return this.setOrderStartAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.type.ReservationGroup.Period.prototype.hasOrderStartAt = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional google.protobuf.Timestamp order_end_at = 3;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.type.ReservationGroup.Period.prototype.getOrderEndAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 3));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.type.ReservationGroup.Period} returns this
*/
proto.type.ReservationGroup.Period.prototype.setOrderEndAt = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.type.ReservationGroup.Period} returns this
 */
proto.type.ReservationGroup.Period.prototype.clearOrderEndAt = function() {
  return this.setOrderEndAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.type.ReservationGroup.Period.prototype.hasOrderEndAt = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional google.protobuf.Timestamp delivery_start_at = 4;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.type.ReservationGroup.Period.prototype.getDeliveryStartAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 4));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.type.ReservationGroup.Period} returns this
*/
proto.type.ReservationGroup.Period.prototype.setDeliveryStartAt = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.type.ReservationGroup.Period} returns this
 */
proto.type.ReservationGroup.Period.prototype.clearDeliveryStartAt = function() {
  return this.setDeliveryStartAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.type.ReservationGroup.Period.prototype.hasDeliveryStartAt = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional google.protobuf.Timestamp delivery_end_at = 5;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.type.ReservationGroup.Period.prototype.getDeliveryEndAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 5));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.type.ReservationGroup.Period} returns this
*/
proto.type.ReservationGroup.Period.prototype.setDeliveryEndAt = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.type.ReservationGroup.Period} returns this
 */
proto.type.ReservationGroup.Period.prototype.clearDeliveryEndAt = function() {
  return this.setDeliveryEndAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.type.ReservationGroup.Period.prototype.hasDeliveryEndAt = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional bool is_varied_order_date_by_product = 6;
 * @return {boolean}
 */
proto.type.ReservationGroup.Period.prototype.getIsVariedOrderDateByProduct = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.type.ReservationGroup.Period} returns this
 */
proto.type.ReservationGroup.Period.prototype.setIsVariedOrderDateByProduct = function(value) {
  return jspb.Message.setProto3BooleanField(this, 6, value);
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.type.ReservationGroup.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.type.ReservationGroup} returns this
 */
proto.type.ReservationGroup.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.type.ReservationGroup.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.type.ReservationGroup} returns this
 */
proto.type.ReservationGroup.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string description = 3;
 * @return {string}
 */
proto.type.ReservationGroup.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.type.ReservationGroup} returns this
 */
proto.type.ReservationGroup.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string cover_image_url = 4;
 * @return {string}
 */
proto.type.ReservationGroup.prototype.getCoverImageUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.type.ReservationGroup} returns this
 */
proto.type.ReservationGroup.prototype.setCoverImageUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string site_category_id = 5;
 * @return {string}
 */
proto.type.ReservationGroup.prototype.getSiteCategoryId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.type.ReservationGroup} returns this
 */
proto.type.ReservationGroup.prototype.setSiteCategoryId = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * repeated Period periods = 6;
 * @return {!Array<!proto.type.ReservationGroup.Period>}
 */
proto.type.ReservationGroup.prototype.getPeriodsList = function() {
  return /** @type{!Array<!proto.type.ReservationGroup.Period>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.type.ReservationGroup.Period, 6));
};


/**
 * @param {!Array<!proto.type.ReservationGroup.Period>} value
 * @return {!proto.type.ReservationGroup} returns this
*/
proto.type.ReservationGroup.prototype.setPeriodsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 6, value);
};


/**
 * @param {!proto.type.ReservationGroup.Period=} opt_value
 * @param {number=} opt_index
 * @return {!proto.type.ReservationGroup.Period}
 */
proto.type.ReservationGroup.prototype.addPeriods = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 6, opt_value, proto.type.ReservationGroup.Period, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.type.ReservationGroup} returns this
 */
proto.type.ReservationGroup.prototype.clearPeriodsList = function() {
  return this.setPeriodsList([]);
};


/**
 * repeated FeatureProduct feature_products = 7;
 * @return {!Array<!proto.type.ReservationGroup.FeatureProduct>}
 */
proto.type.ReservationGroup.prototype.getFeatureProductsList = function() {
  return /** @type{!Array<!proto.type.ReservationGroup.FeatureProduct>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.type.ReservationGroup.FeatureProduct, 7));
};


/**
 * @param {!Array<!proto.type.ReservationGroup.FeatureProduct>} value
 * @return {!proto.type.ReservationGroup} returns this
*/
proto.type.ReservationGroup.prototype.setFeatureProductsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 7, value);
};


/**
 * @param {!proto.type.ReservationGroup.FeatureProduct=} opt_value
 * @param {number=} opt_index
 * @return {!proto.type.ReservationGroup.FeatureProduct}
 */
proto.type.ReservationGroup.prototype.addFeatureProducts = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 7, opt_value, proto.type.ReservationGroup.FeatureProduct, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.type.ReservationGroup} returns this
 */
proto.type.ReservationGroup.prototype.clearFeatureProductsList = function() {
  return this.setFeatureProductsList([]);
};


goog.object.extend(exports, proto.type);
